module.exports = __webpack_public_path__ + "static/media/timetable-smart.9703c02a.svg";